import { useEffect } from 'react';

import { useSVGElementWidth } from '@/hooks/useSVGElementWidth';
import { useIsMobileScreen } from '@/hooks/useMedia';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { VisxText } from '@/components/VisxText';

type Props = {
  x: number;
  y: number;
  fill: string;
  textAnchor: 'start' | 'middle' | 'end';
  children: string;
  onWidthUpdate: (width: number) => void;
};

export const TitleText = ({
  x,
  y,
  fill,
  textAnchor,
  children,
  onWidthUpdate,
}: Props) => {
  const [ref, svgWidth] = useSVGElementWidth();

  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  useEffect(() => {
    onWidthUpdate(svgWidth);
  }, [onWidthUpdate, svgWidth]);

  return (
    <VisxText
      innerRef={ref}
      x={x}
      y={y}
      verticalAnchor="end"
      textAnchor={textAnchor}
      fill={fill}
      typography={isMobileScreen ? 'tiny' : 'xSmall'}
      lineHeight={17}
    >
      {children}
    </VisxText>
  );
};
